export const LEVELS_TO_SHOW_USE_BLENDED_RATE = [
  'LocationRateSetting',
  'LocationPositionRateSetting',
  'MarketPositionRateSetting',
];

export const LOCATION_LEVEL_RATES = [
  'AgencyLocationRateSetting',
  'AgencyLocationPositionRateSetting',
  'LocationRateSetting',
  'LocationPositionRateSetting',
];
